module.exports = __webpack_public_path__ + "static/media/more-applications@3x.b395f341.png";